import React, { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';

type Props = {
  targetDate: string;
  targetTime: string;
};

export const CountdownTimer = ({ targetDate, targetTime }: Props) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const [day, month, year] = targetDate.split('/').map(Number);
      const [time, period] = targetTime.split(' ');
      const [hours, minutes, seconds] = time.split(':').map(Number);
      
      let targetHours = hours;
      if (period === 'PM' && hours !== 12) targetHours += 12;
      if (period === 'AM' && hours === 12) targetHours = 0;

      const target = new Date(year, month - 1, day, targetHours, minutes, seconds);
      const now = new Date();
      const difference = target.getTime() - now.getTime();

      if (difference <= 0) {
        return { days: 0, hours: 0, minutes: 0, seconds: 0 };
      }

      return {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      };
    };

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate, targetTime]);

  const isPastDate = new Date() > new Date(targetDate.split('/').reverse().join('-'));

  if (isPastDate) {
    return (
      <div className="flex items-center gap-2 text-gray-500">
        <Clock size={16} />
        <span>تم الوصول</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 text-primary-600">
      <Clock size={16} />
      <div className="flex items-center gap-1 text-sm">
        <div className="bg-primary-50 px-2 py-1 rounded">
          {String(timeLeft.days).padStart(2, '0')}d
        </div>
        <div className="bg-primary-50 px-2 py-1 rounded">
          {String(timeLeft.hours).padStart(2, '0')}h
        </div>
        <div className="bg-primary-50 px-2 py-1 rounded">
          {String(timeLeft.minutes).padStart(2, '0')}m
        </div>
        <div className="bg-primary-50 px-2 py-1 rounded">
          {String(timeLeft.seconds).padStart(2, '0')}s
        </div>
      </div>
    </div>
  );
};